import App from "@frog/source/models/App.js"
import Tiled from "@frog/source/utility/integration/Tiled.js"
import Random from "@frog/source/utility/Random.js"
import * as PlotSteps from "@frog/source/data/plot/steps.js"
import * as PlotConditions from "@frog/source/data/plot/conditions.js"
import * as PlotScripts from "@frog/source/data/plot/scripts.js"
import Navigation from "@frog/source/models/Navigation.js"
import Zone from "@frog/source/models/Zone.js"
import Step from "@frog/source/models/Step.js"

import player from "@frog/source/data/games/pirates/player.js"
const PLAYER_CHARACTER = "swashbuckler"

export default {
    "slug": "volcano",
    "hasPreparePhase": false,

    "stage": {
        "images": [
            require("./tiles.png"),
        ],
        "units": require("./units.json"),
        "world": Tiled.parse({
            "tilemap": require("./tiles.json"),
            "tileset": require("@frog/source/data/levels/tileset.json"),
            "spots": require("./spots.json"),
        }),
        "configuration": {
            "darkness": true,
        },
        "conditions": [
            {
                // Chapter start
                "type": "turn:0:start",
                "title": "Chapter start",
                "events": [
                    PlotSteps.PlayStinger("Pirate:Stinger:Opening:Finale"),
                    PlotSteps.ChapterStart([
                        "Chapter 3",
                        "The Volcano",
                        "In Which",
                        "Eleanor crawls through the caves",
                        "and fights for the lost treasure."
                    ]),
                    // Music starts
                    PlotSteps.PlayAudio("Pirate:Music:TreasureIsland"),
                    PlotSteps.SpawnPlayerPartyScript({"spotTag": "spawn"}),
                    "SWASHBUCKLER: This is it, the legendary treasure island.",
                    "CASTAWAY: I did not think I would ever return to these accursed shores.",
                    "CASTAWAY: Turn back, lass. You may yet still save your soul.",
                    "CASTAWAY: These shores are haunted with hordes of undead. And you may yet join them.",
                    "SWASHBUCKLER: Not if we work together!",
                    PlotSteps.CloseRibbitScene(),
                ]
            },
            {
                "type": "before attacking",
                "canBeTriggered": (stage, performer, target) => {
                    return performer.key == "castaway"
                        && target.imageKey == "skeleton"
                        && stage.flags["CastawayGaveBlessing"] != true
                        && stage.currentEncounterKey >= 2
                },
                "events": [
                    "CASTAWAY: Hello, my old friend. May this grant you rest.",
                    Step.flag("CastawayGaveBlessing", true),
                    PlotSteps.MarkAchievement("ACH_REAPER_MAN"),
                    PlotSteps.CloseRibbitScene(),
                ]
            },
            {
                // Next encounter starts
                "type": "condition",
                "title": "Next Encounter",
                "isWinCondition": true,
                "condition": (stage) => {
                    return stage.currentEncounterKey == "1"
                        && getUnitCount(stage, {"encounterKey": "1", "unaffiliation": stage.player.affiliation}) == 0
                },
                "events": [
                    // Heroes move to the next encounter
                    PlotSteps.MoveEncounterScript({"nextEncounterKey": "2", "spotTag": "spawn"})
                ]
            },
            // {
            //     // Reinforcements appear
            //     "type": "condition",
            //     "title": "Reinforcements appear!",
            //     "condition": (stage) => {
            //         return stage.currentEncounterKey == "2"
            //             && stage.turn.number == 2
            //             && stage.turn.phase == "start"
            //     },
            //     "events": [
            //         // The knight dashes in
            //         PlotSteps.SpawnUnitAtSpot({"spotTag": "spawn-knight", "protounit": {"key": "knight", "affiliation": "good"}}),
            //
            //         "KNIGHT: My lady, I have come with reinforcements.",
            //         PlotSteps.CloseRibbitScene(),
            //
            //         // The spritely bard races in as well
            //         PlotSteps.SpawnUnitAtSpot({"spotTag": "spawn-bard", "protounit": {"key": "bard", "affiliation": "good"}}),
            //
            //         "BARD: We're here to help!!",
            //         PlotSteps.CloseRibbitScene(),
            //     ]
            // },
            {
                // Next encounter starts
                "type": "condition",
                "title": "Next Encounter",
                "isWinCondition": true,
                "condition": (stage) => {
                    return stage.currentEncounterKey == "2"
                        && getUnitCount(stage, {"encounterKey": "2", "unaffiliation": stage.player.affiliation}) == 0
                },
                "events": [
                    // Heroes move to the next encounter
                    PlotSteps.MoveEncounterScript({"nextEncounterKey": "3", "spotTag": "spawn"}),
                    "Eleanor: Finally, the treasure vault!",
                    "Eleanor: But first, we must deal with the guards.",
                    PlotSteps.CloseRibbitScene(),
                ]
            },
            {
                // Striking Gold
                "type": "condition",
                "title": "Treasure at last!",
                "isWinCondition": true,
                "condition": (stage) => {
                    return stage.currentEncounterKey == "3"
                        && getUnitCount(stage, {"encounterKey": "3", "unaffiliation": stage.player.affiliation}) == 0
                },
                "events": [
                    "*inserts key*",
                    "*rumbling earthquakes shake the caves*",
                    // Heroes move to the final encounter
                    PlotSteps.MoveEncounterScript({"nextEncounterKey": "4", "spotTag": "spawn"}),
                    "SWASHBUCKLER: The lost treasure of <captain>. They will tell our tales for generations!",
                    PlotSteps.CloseRibbitScene(),
                ]
            },
            {
                "type": "condition",
                "condition": (stage) => {
                    return stage.currentEncounterKey == "4"
                        && stage.turn.number == 2
                        && stage.turn.phase == "start"
                        && stage.flags["Lava"] != true
                },
                "events": [
                    "SWASHBUCKLER: Step lightly!! It’s getting hot in here.",
                    Step.flag("Lava", true),
                ]
            },
            {
                // This be MUTINY
                "type": "condition",
                "title": "What's this? MUTINY??",
                "condition": (stage) => {
                    return stage.currentEncounterKey == "4"
                        && getUnitCount(stage, {"encounterKey": "4", "unaffiliation": stage.player.affiliation}) == 0
                        && getUnitCount(stage, {"encounterKey": "4", "affiliation": stage.player.affiliation}) > 2
                        && stage.flags["FirstBetrayal"] != true
                },
                "events": [
                    ":...",
                    ":.....",
                    ":.......",
                    // The rogues start backstabbing!
                    PlotSteps.PlayAudio("Pirate:Music:Mutiny"),

                    ifUnitIsAliveAndAllied("swindler", [
                        Step.deltastage({"camera": {"unitKey": "swindler"}}),
                        PlotSteps.Wait(300),
                        "Sylvester: Stop right there, captain.",
                        "Sylvester: This treasure is mine.",

                        Step.deltastage({"unit": {"key": "swindler", "affiliation": "blue"}}),
                        "SYLVESTER HAS MUTINIED.",

                        Step.deltastage({"camera": {"unitKey": null}}),
                    ]),

                    ifUnitIsAliveAndAllied("bard", [
                        Step.deltastage({"camera": {"unitKey": "bard"}}),
                        PlotSteps.Wait(300),
                        "Robin: All for one, as they say.",

                        Step.deltastage({"unit": {"key": "bard", "affiliation": "blue"}}),
                        "ROBIN HAS MUTINIED",

                        Step.deltastage({"camera": {"unitKey": null}}),
                    ]),

                    "Smee: I’m still with you, lass. Let them break their weapons on my bones.",
                    "Smee’s Bird: Here we go again.",

                    PlotSteps.CloseRibbitScene(),
                    Step.flag("FirstBetrayal", true),
                    Step.deltastage({"turn": {"number": 2, "phase": "start"}}),
                    {"type": "restart"},
                ]
            },

            {
                // Chaos is her ladder
                "type": "condition",
                "title": "Chaos is her ladder",
                "condition": (stage) => {
                    return stage.currentEncounterKey == "4"
                        && stage.turn.number == 4
                        && stage.turn.phase == "start"
                        && (stage.flags["FirstBetrayal"] == true || stage.flags["FinalBetrayal"] == true)
                        && stage.flags["YakuzaAppears"] != true
                },
                "events": [
                    // The yakuza roll in
                    PlotSteps.SpawnUnitAtSpot({"spotTag": "spawn", "protounit": {"key": "yakuza", "affiliation": "purple"}}),
                    "YAKUZA: Aha, excellent work. You have led us right to the treasure.",
                    "YAKUZA: Now perish.",
                    PlotSteps.SpawnUnitAtSpot({"spotTag": "spawn", "protounit": {"key": "a", "jobKey": "pirates/gun", "imageKey": "mafioso", "affiliation": "purple", "ai": {"behaviors": ["non-player-enemies first"]}}}),
                    PlotSteps.SpawnUnitAtSpot({"spotTag": "spawn", "protounit": {"key": "b", "jobKey": "pirates/gun", "imageKey": "mafioso", "affiliation": "purple", "ai": {"behaviors": ["non-player-enemies first"]}}}),
                    Step.flag("YakuzaAppears", true)
                ]
            },

            {
                "type": "condition",
                "title": "And the last pin drops",
                "isWinCondition": true,
                "condition": (stage) => {
                    return stage.currentEncounterKey == "4"
                        && stage.flags["FinalBetrayal"] != true
                        && stage.units[PLAYER_CHARACTER]?.isDead != true
                        && stage.units["castaway"]?.isDead != true
                        && getUnitCount(stage, {"encounterKey": "4", "unaffiliation": stage.player.affiliation}) == 0
                        // && getUnitCount(stage, {"encounterKey": "4", "affiliation": stage.player.affiliation}) == 2
                },
                "events": [
                    // A final betrayal
                    Step.deltastage({"camera": {"unitKey": "castaway"}}),
                    PlotSteps.Wait(300),
                    "CASTAWAY: ...",
                    "SWASHBUCKLER: Oh no, not you too.",
                    "CASTAWAY: You know not what this treasure can do.",

                    Step.deltastage({"unit": {"key": "castaway", "affiliation": "bad", "power": 5}}),
                    "SMEE HAS MUTINIED.",

                    Step.deltastage({"camera": {"unitKey": null}}),
                    Step.flag("FinalBetrayal", true),
                    Step.deltastage({"turn": {"number": 2, "phase": "start"}}),
                    {"type": "restart"},
                ]
            },

            {
                "type": "condition",
                "title": "Yours for the taking",
                "isWinCondition": true,
                "condition": (stage) => {
                    return stage.currentEncounterKey == "4"
                        && getUnitCount(stage, {"encounterKey": "4", "unaffiliation": stage.player.affiliation}) == 0
                        && stage.units[PLAYER_CHARACTER].isDead == false
                },
                "events": [
                    PlotSteps.PlayStinger("Pirate:Stinger:Victory"),
                    "SWASHBUCKLER: Aha!! And such are the adventures of Eleanor, <titles titles titles new title>",
                    "SWASHBUCKLER: ...",
                    "SWASHBUCKLER: Wait, where’s my ship?",
                    PlotSteps.CloseRibbitScene(),
                    PlotSteps.ChapterSuccessClassic(),
                    {"func": () => Navigation.go("/credits")},
                ]
            },
            {
                "type": "condition",
                "title": "Loss",
                "condition": function(stage) {
                    return stage.units[PLAYER_CHARACTER].isDead == true
                },
                "events": [
                    // Failure banner spreads on the screen
                    PlotSteps.ChapterFailure(),
                    // Chapter restarts
                    {"func": () => App.game.chapter.restart()},
                ]
            },
            {
                "type": "condition",
                "condition": (stage) => {
                    return stage.currentEncounterKey == "4"
                        && stage.turn.number >= 1
                        && stage.turn.number % 2 == 0
                        && stage.turn.phase == "start"
                },
                "events": [
                    PlotSteps.SpawnUnitAtSpot({
                        "spotTag": "spawn-lava",
                        "protounit": {
                            "type": "spot",
                            "affiliation": "nothing",
                            "properties": ["visible"],
                            "intent": "kill",
                            "imageKey": "red"
                        }
                    }),
                ]
            },
            {
                "type": "death",
                "unitKey": "swindler",
                "events": [
                    "SWINDLER: Ah, not this time either. Ah well.",
                    "SWINDLER: Until next time, Eleanor. ;)",
                ]
            },
            {
                "type": "death",
                "unitKey": "bard",
                "events": [
                    "BARD: The End! And won't this be a story to tell.",
                ]
            },
            {
                "type": "death",
                "unitKey": "mercenary",
                "events": [
                    "MERCENARY: I fold. Never should've been a betting man.",
                ]
            },
        ]
    },
}

function ifUnitIsAliveAndAllied(unitKey, events) {
    return (stage) => {
        const alliedAffiliation = stage.player.affiliation
        if(stage.units[unitKey] != undefined
        && stage.units[unitKey].isDead != true
        && stage.units[unitKey].hasBeenRemoved != true
        && stage.units[unitKey].affiliation == alliedAffiliation) {
            return events
        }
    }
}

function getUnitCount(stage, {encounterKey, affiliation, unaffiliation}) {
    const units = Object.values(stage.units).filter((unit) => {
        if(unit.affiliation == "none") return false
        if(unit.affiliation == "nothing") return false
        if(unit.isDead == true) return false
        if(unit.hasBeenRemoved == true) return false
        if(unit.type == "zone") return false
        if(unit.type == "spot") return false
        if(Zone.isInBounds(stage.encounters[encounterKey || stage.currentEncounterKey], unit.position) != true) return false

        if(affiliation != undefined) {
            return unit.affiliation == affiliation
        }
        if(unaffiliation != undefined) {
            return unit.affiliation != unaffiliation
        }

        return true
    })

    return units.length
}
